import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';

import './traininggroup_list.scss';

import {
  DataGrid,
  Sorting, Selection, HeaderFilter, Scrolling, SearchPanel,
  Export, Column, Toolbar, Item, LoadPanel,
  Editing

} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';


import { FormPopup, TraininggroupNewForm, TraininggroupPanel } from '../../components';
import { TraininggroupStatus } from '../../components';

import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate } from 'react-router-dom';
import { onExporting } from '../../utils/exporter';
import { exportFormats } from '../../shared/constants';
import { useMsal } from "@azure/msal-react";


const dropDownOptions = { width: 'auto' };



export const TraininggroupList = () => {
      const { instance, accounts } = useMsal();
  const [gridDataSource, setGridDataSource] = useState();
  const [dataSource_user, setdataSource_user] = useState();
  const [popupVisible, setPopupVisible] = useState(false);
  const [formDataDefaults, setFormDataDefaults] = useState({});
  const gridRef = useRef(null);
  const navigate = useNavigate();

  let newTraininggroupData;

  useEffect(() => {
    getApiToken(instance, accounts).then(token => {
      setGridDataSource({
        store: createStore({
          key: 'traininggroupId',
          loadUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/Traininggroups`,
          insertUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/InsertTraininggroup`,
          updateUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/UpdateTraininggroup`,
          deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/DeleteTraininggroup`,
          onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
              'Authorization': "Bearer " + token
            };
          },
        })
      });

      const dataSource_user = createStore({
        key: 'userId',
        loadUrl: `${process.env.REACT_APP_serverEndpoint}/User/UsersBasic`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            'Authorization': "Bearer " + token
          };
        },
      });

      dataSource_user.load().done(function (data) {
        setdataSource_user(data);
      })

    });

  }, []);

  const changePopupVisibility = useCallback((isVisble) => {
    setPopupVisible(isVisble);
  }, []);


  const onAddTraininggroupClick = useCallback(() => {
    setPopupVisible(true);
  }, []);



  const refresh = useCallback(() => {
    gridRef.current?.instance().refresh();
  }, []);

  const onDataChanged = useCallback((data) => {
    newTraininggroupData = data;
  }, []);

  const onRowClick = useCallback(({ data }) => {
    const traininggroupId = data.traininggroupId;
    const groupname = data.groupname;
    navigate(`/athlete/list?traininggroupId=${traininggroupId}&groupname=${encodeURIComponent(groupname)}`);
  }, [navigate]);

  const onSaveClick = useCallback(() => {
    
    getApiToken(instance, accounts).then(token => {
      const datastore = createStore({
        key: 'traininggroupId',
        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/InsertTraininggroup`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            'Authorization': "Bearer " + token
          };
        },
      });

      datastore.insert(newTraininggroupData).then((data) => {

        notify({
          message: `Neue Trainingsgruppe "${data.groupname}" gespeichert`,
          position: { at: 'bottom center', my: 'bottom center' }
        }
          ,
          'success'
        );
        setFormDataDefaults({ ...formDataDefaults });
        setPopupVisible(false);
        refresh();
      }).catch((error) => {
        notify({
          message: `Fehler beim Speichern der Trainingsgruppe "${newTraininggroupData.groupname}"`,
          position: { at: 'bottom center', my: 'bottom center' }
        },
          'error'
        );
      });
    });
  }, []);

  return (
    <div className='view traininggroup-list'>
      <div className='view-wrapper view-wrapper-traininggroup-list list-page'>
        <DataGrid
          className='grid theme-dependent'
          noDataText=''
          focusedRowEnabled
          height='100%'
          dataSource={gridDataSource}
          onRowClick={onRowClick}
          onExporting={onExporting}
          allowColumnReordering
          showBorders
          ref={gridRef}
          remoteOperations={true}
        >
          <LoadPanel showPane={false} />
          <SearchPanel visible placeholder='Trainingsgruppe suchen' />
          <Export enabled allowExportSelectedData formats={exportFormats} />
          <Selection
            selectAllMode='allPages'
            showCheckBoxesMode='always'
            mode='multiple'
          />
          <HeaderFilter visible />
          <Sorting mode='multiple' />
          <Scrolling mode='virtual' />
          <Editing allowDeleting={true} allowUpdating= {true}/>
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Trainingsgruppen</div>
            </Item>

            <Item location='after' locateInMenu='auto'>
              <Button
                icon='plus'
                text='Neue Trainingsgruppe'
                type='default'
                stylingMode='contained'
                onClick={onAddTraininggroupClick}
              />
            </Item>
            <Item
              location='after'
              locateInMenu='auto'
              showText='inMenu'
              widget='dxButton'
            >
              <Button
                icon='refresh'
                text='Refresh'
                stylingMode='text'
                onClick={refresh}
              />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item name='exportButton' />
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>

          <Column dataField="groupname" caption="Name" sortIndex={7} sortOrder='asc' hidingPriority={1} allowHiding={true} />
          <Column dataField="userId" caption="Trainer" hidingPriority={0} allowHiding={true} lookup={{ dataSource: dataSource_user, valueExpr: 'userId', displayExpr: 'displayName', allowClearing: true   }} />




        </DataGrid>
        {/* <TraininggroupPanel traininggroupId={traininggroupId} isOpened={isPanelOpened} changePanelOpened={changePanelOpened} changePanelPinned={changePanelPinned} /> */}
        <FormPopup title='Neue Trainingsgruppe' visible={popupVisible} setVisible={changePopupVisibility} onSave={onSaveClick}>
          <TraininggroupNewForm initData={formDataDefaults} onDataChanged={onDataChanged} userData={dataSource_user} />
        </FormPopup>
      </div>
    </div>
  );
};

